import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BusquedaTesoroPreguntaPage } from './busqueda-tesoro-pregunta';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    BusquedaTesoroPreguntaPage,
  ],
  imports: [
    IonicPageModule.forChild(BusquedaTesoroPreguntaPage),
    ComponentsModule
  ],
})
export class BusquedaTesoroPreguntaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-pregunta/busqueda-tesoro-pregunta.module.ts